/** Kinds of indicator inputs (the Inputs tab of the settings modal, TV-17). */
export const INPUT_TYPE = {
  NUMBER: "number",
  SELECT: "select",
};

/** How a plot of an indicator is drawn. */
export const PLOT_TYPE = {
  LINE: "line",
  HISTOGRAM: "histogram",
  // Separate points: Parabolic SAR
  DOTS: "dots",
  // Marks above or below bars: Fractal
  MARKERS: "markers",
  // Background between two lines (`between`): Bollinger Bands, channels
  FILL: "fill",
};

/** Which colour a histogram column (or a two-colour line) takes. */
export const COLOR_RULE = {
  // One colour, no down colour (OsMA)
  SINGLE: "single",
  // Up when higher than the previous value (or there is none), as TV AO / AC
  TREND: "trend",
  // Up when the bar closed at or above its open (Volume)
  BAR: "bar",
};

/** Colours of the chart theme a plot or a level may use besides the palette. */
export const THEME_COLOR = {
  LEVEL: "indicatorLevel",
};

/** Moving average types of PO (research §1.4), in the order of its select. */
export const MA_TYPE = {
  SMA: "SMA",
  WMA: "WMA",
  EMA: "EMA",
  SMMA: "SMMA",
  TMA: "TMA",
};

/** Price a calculation reads from a bar. */
export const PRICE_SOURCE = {
  CLOSE: "close",
  OPEN: "open",
  HIGH: "high",
  LOW: "low",
  HL2: "hl2",
  HLC3: "hlc3",
  OHLC4: "ohlc4",
};

/** Pane of the price chart; an oscillator gets a pane with its own id (the indicator key). */
export const MAIN_PANE_ID = "main";

/** `between` of a FILL plot that fills the space between the first and the last level (CCI). */
export const FILL_BETWEEN_LEVELS = "levels";
